import React, { useState } from "react";
import { View, Text, TouchableOpacity, StyleSheet, Image } from "react-native";
import { RTCView } from "react-native-webrtc";
import { AppTheme } from "../utils/theme";
import { AppIcons } from "../assets/images";
import DeviceInfo from "react-native-device-info";
const isTablet = DeviceInfo.isTablet();

export default function VoiceComponent({
  // @ts-ignore
  players,
  // @ts-ignore
  myColor,
  // @ts-ignore
  isMuted,
  // @ts-ignore
  onToggleMute,
  // @ts-ignore
  playerMuteStates = {},
  remoteStreams = new Map(), // Streams from parent (OnlineGameScreen)
}) {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleMute = () => {
    onToggleMute();
  };

  const renderPlayerVoice = (player: any) => {
    const isMe = player.color === myColor;
    // @ts-ignore
    const isMutedState = isMe ? isMuted : playerMuteStates[player.id] || false;
    const remoteStream = remoteStreams.get(player.id);

    return (
      <View key={player.id} style={[styles.playerVoiceItem]}>
        <View style={styles.playerVoiceInfo}>
          <View style={[styles.colorDot]} />
          <Text style={styles.playerVoiceName} numberOfLines={1}>
            {player.name}
            {isMe ? " (You)" : ""}
          </Text>
        </View>
        <View style={styles.voiceIndicator}>
          <Text style={styles.voiceIcon}>{isMutedState ? "🔇" : "🔊"}</Text>
        </View>

        {/* Hidden RTCView for remote audio playback */}
        {!isMe && remoteStream && (
          <RTCView
            streamURL={remoteStream.toURL()}
            style={styles.hiddenAudioView}
            objectFit="cover"
            // @ts-ignore
            zOrder={RTCView?.ZOrderType?.RTCViewZOrderNone}
          />
        )}
      </View>
    );
  };

  if (!isExpanded) {
    return (
      <View style={styles.compactContainer}>
        {/* <TouchableOpacity
          style={[styles.micButton, isMuted && styles.micButtonMuted]}
        >
          <Text style={styles.micButtonText}>{isMuted ? "🎤" : "🎙️"}</Text>
        </TouchableOpacity> */}
        <TouchableOpacity
          onPress={() => {
            handleToggleMute();
          }}
        >
          <Image
            source={isMuted ? AppIcons.MicMute : AppIcons.MicOn}
            style={styles.micImg}
            resizeMode={"contain"}
          />
        </TouchableOpacity>
      </View>
    );
  }

  return (
    <View style={styles.expandedContainer}>
      <View style={styles.playersList}>{players.map(renderPlayerVoice)}</View>
      <TouchableOpacity
        style={[styles.muteButton, isMuted && styles.muteButtonActive]}
        onPress={handleToggleMute}
      >
        <Text style={styles.muteButtonIcon}>{isMuted ? "🎤" : "🎙️"}</Text>
        <Text style={styles.muteButtonText}>{isMuted ? "Unmute" : "Mute"}</Text>
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  compactContainer: {
    position: "absolute",
    bottom: isTablet ? 150 : 80,
    alignSelf: "center",
  },
  micImg: {
    width: isTablet ? 100 : 60,
    height: isTablet ? 100 : 60,
  },
  micButton: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: AppTheme.colors.green,
    justifyContent: "center",
    alignItems: "center",
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
  },
  micButtonMuted: {
    backgroundColor: AppTheme.colors.red,
  },
  micButtonText: {
    fontSize: 24,
  },
  expandButton: {
    width: 50,
    height: 50,
    borderRadius: 25,
    backgroundColor: AppTheme.colors.black,
    justifyContent: "center",
    alignItems: "center",
    elevation: 5,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
  },
  expandButtonText: {
    fontSize: 24,
  },
  expandedContainer: {
    position: "absolute",
    right: 20,
    top: 100,
    width: 250,
    backgroundColor: "rgba(255,255,255,0.98)",
    borderRadius: 15,
    padding: 15,
    elevation: 8,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 15,
    paddingBottom: 10,
    borderBottomWidth: 2,
  },
  headerTitle: {
    fontSize: 18,
    fontWeight: "bold",
  },
  collapseButton: {
    padding: 5,
  },
  collapseButtonText: {
    fontSize: 16,
  },
  playersList: {
    marginBottom: 15,
  },
  playerVoiceItem: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginBottom: 8,
    borderRadius: 10,
    borderLeftWidth: 4,
    elevation: 1,
  },
  playerVoiceInfo: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  colorDot: {
    width: 16,
    height: 16,
    borderRadius: 8,
    marginRight: 10,
  },
  playerVoiceName: {
    fontSize: 14,
    fontWeight: "600",
    flex: 1,
  },
  voiceIndicator: {
    marginLeft: 10,
  },
  voiceIcon: {
    fontSize: 20,
  },
  muteButton: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    padding: 12,
    borderRadius: 10,
    gap: 8,
  },
  muteButtonActive: {},
  muteButtonIcon: {
    fontSize: 20,
  },
  muteButtonText: {
    fontSize: 16,
    fontWeight: "bold",
  },
  hiddenAudioView: {
    position: "absolute",
    left: -9999,
    width: 1,
    height: 1,
    zIndex: -1,
  },
});
